import { EntityMetadataMap } from '@ngrx/data';

export const KE_WORKFLOW_SETTINGS_PRESETS_BINDING_ENTITY_NAME = 'ke-workflow-settings-presets-binding';

const entityMetadata: EntityMetadataMap = {
  [KE_WORKFLOW_SETTINGS_PRESETS_BINDING_ENTITY_NAME]: {
    entityDispatcherOptions: { optimisticAdd: false, optimisticUpdate: false },
  },
};

export const workflowSettingsPresetsBindingEntityConfig = {
  entityMetadata,
};
